<mat-dialog-content>
  <span>{{message}}</span>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="dialogRef.close(false)">Anuluj</button>
  <button mat-button (click)="dialogRef.close(true)">{{okButtonLabel}}</button>
</mat-dialog-actions>
